import React from 'react';
import PropTypes from 'prop-types';
import CollectionItem from '../item/index';
import withStyles from 'material-ui/styles/withStyles';
import styles from './styles';

const CollectionList = props => {
	const {
		items,
		filesCount,
		classes,
		handleShowFiles,
		language
	} = props;

	return (
		<div className={classes.container}>
			{items.filter(it => it.language === language)
				.sort((a, b) => a.sortOrder - b.sortOrder)
				.map(item => (
					<CollectionItem
						key={item.id}
						item={item}
						filesCount={filesCount[item.id] || 0}
						handleShowFiles={handleShowFiles}
					/>
				))}
		</div>
	);
};

CollectionList.propTypes = {
	classes: PropTypes.object.isRequired,
	filesCount: PropTypes.object.isRequired,
	items: PropTypes.array.isRequired,
	language: PropTypes.string.isRequired,
	handleShowFiles: PropTypes.func.isRequired
};

export default withStyles(styles)(CollectionList);



// WEBPACK FOOTER //
// ./src/client/components/main/collections/list/list.jsx